import React from 'react';
import { PANCAKE_LIGHT } from '@bubble-ui/particle-design-versions';
var ThemeNameContext = /*#__PURE__*/React.createContext(PANCAKE_LIGHT);
var ThemeNameConsumer = ThemeNameContext.Consumer;
var ThemeNameProvider = _ref => {
  var {
    children,
    value
  } = _ref;
  return /*#__PURE__*/React.createElement(ThemeNameContext.Provider, {
    value: value
  }, children);
};
ThemeNameProvider.displayName = 'ThemeNameProvider';
var useThemeName = () => React.useContext(ThemeNameContext);
export { ThemeNameContext, ThemeNameConsumer, ThemeNameProvider, useThemeName };
//# sourceMappingURL=index.js.map